
import { ISettingsResponse } from '../../shared/models/settings.model';
import { of } from 'rxjs/internal/observable/of';
import { throwError } from 'rxjs/internal/observable/throwError';



export class SettingsAdapter {
    static toSettings(response: ISettingsResponse) {
        if (!response.status || `${response.status.code}` === '200') {
            return of(response.data);
        } else {
            return throwError(`${response.status?.code || 'Unknown'} - ${response.status?.messages?.join(', ') || 'Error'}`);
        }
    }
}



 
